module.exports = "/*\n * Application global variables.\n */\n.btn-xs {\n  font: 400 10.3333px Arial !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component-table/button-download-review/button-download-review.component.scss
// module id = ./src/app/shared/component-table/button-download-review/button-download-review.component.scss
// module chunks = main